import * as R from "ramda";

const STATE_ACTION_NAMES = ["setNodeKVPair"];

function isStateAction(action: DocAction): action is SetNodeKVPairAction {
  return STATE_ACTION_NAMES.includes(action.action);
}

export function performActions(actions: Array<DocAction>, currentUser: CurrentUser) {
  const [stateActions, otherActions] = R.partition(isStateAction, actions);

  const stateActionsGroupByTarget = R.groupBy((stateAction) => stateAction.arguments.targetType ? `${stateAction.arguments.targetType}--${stateAction.arguments.targetId}` : `${currentUser.addStateTargetType}--${currentUser.addStateTargetId}`, stateActions);

  Object.values(stateActionsGroupByTarget).forEach((actionsForTarget) => {
    if (!actionsForTarget) { return; }

    const targetType = actionsForTarget[0].arguments.targetType;
    const targetId = actionsForTarget[0].arguments.targetId;

    const unmergedStates = actionsForTarget.map((action) => {
      switch(action.action) {
        case "setNodeKVPair":
          return {[action.arguments.uid]: {[action.arguments.key]: action.arguments.value}};
        }
    });

    const state = R.reduce(R.mergeDeepLeft, {}, unmergedStates);

    switch (targetType) {
      case "activity":
        if (!targetId) { return; }
        currentUser.activityUserStatesByActivityId[targetId]._actions.addState(state);

        break;
      case "document":
        currentUser.addDocumentUserState(state);
        break;
      default:
        currentUser.addState(state);
        break;
    }
  });

  otherActions.forEach((action, index, array) => {
    switch(action.action) {
      case "openNode":
        // currentUser.openSection(action.arguments.uid); // TODO: Add Again
        break;
      case "openLink":
        Turbo.visit(action.arguments.href);
        break;
      // TODO: Add Rollbar warning for case where action does not exist
    }
  });
}
